import { Box } from '@chakra-ui/react';
import classNames from 'classnames';
import { FC, SyntheticEvent, useContext, useEffect } from 'react';
import { GamesContainer } from './GamesContainer';
import { Header } from './Header';
import { Joinable } from 'types/Joinable';
import { JoinableGames } from './JoinableGames';
import { MPThemeContext, useIsEmbedded } from '../../providers';
import { NormalizedGame } from 'types/Games';
import styles from './GamesPage.module.css';
export interface GamesPageProps {
  activeFilter: string;
  currentPage: number;
  games: NormalizedGame[];
  managedGames?: NormalizedGame[];
  joinableGames?: Joinable[];
  assumedUserName?: string;
  isPending?: boolean;
  numberOfRows: number;
  totalManaged: number;
  totalGames: number;
  onFilterChange: (value: string) => void;
  onPageChange: (pageNumber: number) => void;
  onWinningsClick?: (event: SyntheticEvent) => void;
}
export const GamesPage: FC<GamesPageProps> = ({
  activeFilter,
  currentPage,
  games,
  managedGames,
  joinableGames,
  assumedUserName,
  isPending,
  numberOfRows,
  totalManaged,
  totalGames,
  onFilterChange,
  onPageChange,
  onWinningsClick
}) => {
  const {
    isMobile
  } = useContext(MPThemeContext);
  const {
    isEmbedded: isEmbeddedMode
  } = useIsEmbedded();
  useEffect(() => {
    if (!isEmbeddedMode) return;
    const style = document.createElement('style');
    style.setAttribute('data-games-page-embedded', '');
    style.textContent = ['@media screen and (max-width: 768px) {', '  body > div > div:first-child { min-height: 0 !important; padding-bottom: 0 !important; }', '  main { padding-bottom: 0 !important; min-height: 0 !important; }', '}'].join('\n');
    document.head.appendChild(style);
    return () => {
      style.remove();
    };
  }, [isEmbeddedMode]);
  return <Box className={classNames(styles.gamesPageRoot, {
    [styles.embedded]: isEmbeddedMode
  })} data-sentry-element="Box" data-sentry-component="GamesPage" data-sentry-source-file="GamesPage.tsx">
      {/* Header */}
      <Header activeFilter={activeFilter} isMobile={isMobile} onFilterChange={onFilterChange} data-sentry-element="Header" data-sentry-source-file="GamesPage.tsx" />
      <Box display="flex" flexDirection="column" gap={'2dvh'} paddingY={6} paddingX={3} data-sentry-element="Box" data-sentry-source-file="GamesPage.tsx">
        {/* Joinable Games */}
        {joinableGames && <JoinableGames joinableGames={joinableGames} />}
        {/* Games Container */}
        <GamesContainer activeFilter={activeFilter} assumedUserName={assumedUserName} currentPage={currentPage} games={games} isMobile={isMobile || false} isPending={isPending} managedGames={managedGames || []} numberOfRows={numberOfRows} onPageChange={onPageChange} onWinningsClick={onWinningsClick} totalManaged={totalManaged} totalGames={totalGames} data-sentry-element="GamesContainer" data-sentry-source-file="GamesPage.tsx" />
      </Box>
    </Box>;
};